import { ref } from "vue";

// A single toast slot is all Phase 1 needs (the kill-switch/mode-transition
// result, REQ-CD-P1-CON-05). A module-level singleton mirrors useAnnouncer's
// pattern so `ToastRegion` can live once in AppShell.
export interface ToastState {
  open: boolean;
  title: string;
  description: string;
  variant: "default" | "error";
}

const state = ref<ToastState>({ open: false, title: "", description: "", variant: "default" });

export function useToast() {
  function show(title: string, description = "", variant: ToastState["variant"] = "default"): void {
    state.value = { open: true, title, description, variant };
  }
  function close(): void {
    state.value = { ...state.value, open: false };
  }
  return { state, show, close };
}
